var echarts = require('echarts/lib/echarts');

require('./liquidFillSeries');
require('./liquidFillView');


echarts.registerVisual(
    echarts.util.curry(
        require('echarts/lib/visual/dataColor'), 'liquidFill'
    )
);



//////////////////
// WEBPACK FOOTER
// ./~/echarts-liquidfill/src/liquidFill.js
// module id = 841
// module chunks = 128